<template>
    <div class="sidenav h-100" v-bind:style="{ width: width+ 'px' }">
        <div class="showhide p-2 text-right" v-bind:style="{ width: width+ 'px'}">
            <b-button variant="dark" @click="switchDisplay()">
                <Icon :icon="fullMode ? 'angle-double-left' : 'angle-double-right'"
                      size="1x"
                      style="color: white"></Icon>
            </b-button>
            <b-container>
                <b-row class="pt-2"></b-row>
                <slot></slot>
            </b-container>
        </div>
    </div>
</template>

<script>

  export default {
    name: 'SideNav',
    props: {
      width: {
        type: Number,
        default: 240
      }
    },
    data() {
      return {
        fullMode: true,
      }
    },
    methods: {
      switchDisplay() {
        this.fullMode = !this.fullMode;
        this.$emit('switched', this.fullMode);
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "../../assets/style/base/colors";

    .sidenav {
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        background-color: $dark-grey;
        overflow-x: hidden;
        padding-top: 0;
    }

    .showhide {
        color: $white;
        text-align: center;
    }

</style>
